import gql from 'graphql-tag';
const BUILD_A_KEYBOARD_ACTIVITY_FRAGMENT = gql `
  fragment BuildAKeyboardActivityFragment on BuildAKeyboardActivity {
    rounds {
      id
      characterGroups
      characters
    }
  }
`;
export default BUILD_A_KEYBOARD_ACTIVITY_FRAGMENT;
